"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluckAndFilter = exports.vibrate = exports.sleep = exports.floatFormatter = exports.getIn = exports.dateToNumber = exports.isNumber = exports.ceilToFive = exports.baseFindIndex = exports.baseSlice = exports.some = exports.exists = exports.every = exports.textValidator = exports.debounce = exports.debounceAgg = exports.customColumnsToColDef = exports.sortRows = void 0;
const BoolCellRenderer_1 = __importDefault(require("./BoolCellRenderer"));
const toPath_1 = __importDefault(require("lodash/toPath"));
function sortRows(rows, sortColumn, sortType, sortDirection) {
    if (sortDirection === 'NONE')
        return rows;
    let sortedRows = [...rows];
    switch (sortType) {
        case 'string':
            sortedRows = sortedRows.sort((a, b) => a[sortColumn].localeCompare(b[sortColumn]));
            break;
        case 'boolean':
            sortedRows = sortedRows.sort((a, b) => a[sortColumn] === b[sortColumn] ? 0 : a[sortColumn] ? 1 : -1);
            break;
        case 'numeric':
            sortedRows = sortedRows.sort((a, b) => a[sortColumn] - b[sortColumn]);
            break;
        default:
    }
    return sortDirection === 'DESC' ? sortedRows.reverse() : sortedRows;
}
exports.sortRows = sortRows;
function customColumnsToColDef(customColumns) {
    return customColumns.map((column) => {
        let col = {
            field: 'custom_columns.' + column.field,
            headerName: column.header_name,
        };
        if (column.type === 'boolean') {
            col = {
                ...col,
                cellRenderer: BoolCellRenderer_1.default,
            };
        }
        return col;
    });
}
exports.customColumnsToColDef = customColumnsToColDef;
function debounceAgg(fn, wait = 100) {
    let timeout;
    let aggregate = [];
    return (value) => {
        aggregate.push(value);
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            fn(aggregate);
            aggregate = [];
        }, wait);
    };
}
exports.debounceAgg = debounceAgg;
function debounce(fn, wait = 100) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        // @ts-ignore
        timeout = setTimeout(() => fn.apply(this, args), wait);
    };
}
exports.debounce = debounce;
function textValidator(allowedValues) {
    return (params) => {
        const gridApi = params.api;
        params.newValue = params.newValue ? params.newValue : "";
        // empty fields are always allowed
        const allowed = ["", null, ...allowedValues];
        console.log(allowed);
        console.log(params);
        if (!allowed.includes(params.newValue)) {
            gridApi.flashCells({
                rowNodes: [params.node],
                columns: [params.column.getColId()],
            });
            return false;
        }
        params.data[params.column.getColId()] = params.newValue;
        return true;
    };
}
exports.textValidator = textValidator;
// much faster than Array.prototype.every
function every(list, predicate) {
    if (list == null) {
        return true;
    }
    for (let i = 0; i < list.length; i++) {
        if (!predicate(list[i], i)) {
            return false;
        }
    }
    return true;
}
exports.every = every;
function exists(value, allowEmptyString = false) {
    return value != null && (allowEmptyString || value !== '');
}
exports.exists = exists;
function some(list, predicate) {
    if (list == null) {
        return false;
    }
    for (let i = 0; i < list.length; i++) {
        if (predicate(list[i], i)) {
            return true;
        }
    }
    return false;
}
exports.some = some;
function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) {
        start = -start > length ? 0 : (length + start);
    }
    end = end > length ? length : end;
    if (end < 0) {
        end += length;
    }
    length = start > end ? 0 : ((end - start) >>> 0);
    start >>>= 0;
    var result = Array(length);
    while (++index < length) {
        result[index] = array[index + start];
    }
    return result;
}
exports.baseSlice = baseSlice;
function baseFindIndex(array, predicate, fromIndex, fromRight = false) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while ((fromRight ? index-- : ++index < length)) {
        if (predicate(array[index], index, array)) {
            return index;
        }
    }
    return -1;
}
exports.baseFindIndex = baseFindIndex;
function ceilToFive($number) {
    return Math.ceil($number / 5) * 5;
}
exports.ceilToFive = ceilToFive;
function isNumber(value) {
    return !(value === null || value === '' || isNaN(value));
}
exports.isNumber = isNumber;
// helper for date comparison,     // 29.08.2004 => 20040829
function dateToNumber(date) {
    if (date === undefined || date === null) {
        return null;
    }
    var dateParts = date.split('.');
    var yearNumber = Number(dateParts[2]);
    var monthNumber = Number(dateParts[1]);
    var dayNumber = Number(dateParts[0]);
    return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
exports.dateToNumber = dateToNumber;
/**
 * Deeply get a value from an object via its path.
 */
function getIn(obj, key, def, p = 0) {
    const path = (0, toPath_1.default)(key);
    while (obj && p < path.length) {
        obj = obj[path[p++]];
    }
    return obj === undefined ? def : obj;
}
exports.getIn = getIn;
function floatFormatter(params) {
    return new Intl.NumberFormat('de-DE', {
        useGrouping: false,
    }).format(params.value);
}
exports.floatFormatter = floatFormatter;
;
function sleep(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}
exports.sleep = sleep;
function vibrate(pattern) {
    const canVibrate = ('vibrate' in window.navigator);
    if (canVibrate) {
        window.navigator.vibrate(pattern);
    }
}
exports.vibrate = vibrate;
// Extracts (plucks) the values from array of objects by a given key, filters out values you specify.
function pluckAndFilter(arr, key, exclude) {
    return arr
        .map(item => String(item[key])) // pluck values by key
        .filter(value => !exclude.includes(value)); // filter out unwanted values
}
exports.pluckAndFilter = pluckAndFilter;
